import { TextField } from '@material-ui/core'
import { Controller, Control } from 'react-hook-form'

// Define IInputTextProps interface
interface IInputTextProps {
  name: string
  copy: string
  regex?: RegExp
  type?: 'password' | 'text'
  errorMessage?: string
  errors: { [key: string]: any }
  control: Control<any>
  autoFocus?: boolean
  defaultValue?: string
}

/**
 * Custon `JustiInputText` component declaration.
 * @param {String} name
 * @param {String} copy
 * @param {RegExp} regex
 * @param {String} type
 * @param {String} errorMessage
 * @param {Any} errors
 * @param {Control} control
 * @param {Boolean} autoFocus
 * @param {String} defaultValue
 * @return JustiInputText
 */
export const JustiInputText = ({
  name,
  copy,
  regex,
  errorMessage,
  type,
  errors,
  control,
  defaultValue,
  autoFocus = false,
}: IInputTextProps): JSX.Element => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue ? defaultValue : ''}
      rules={{
        required: true,
        pattern: {
          value: regex ? regex : new RegExp('.*'),
          message: errorMessage ? errorMessage : '',
        },
      }}
      render={({ onChange, value }) => (
        <TextField
          variant="outlined"
          margin="normal"
          fullWidth
          id={name}
          type={type}
          label={copy}
          value={value}
          InputProps={{ style: { backgroundColor: 'white' } }}
          helperText={errors[name] ? errors[name].message : null}
          FormHelperTextProps={{ style: { color: 'secondary' } }}
          error={errors[name] ? true : false}
          onChange={onChange}
          autoFocus={autoFocus}
        />
      )}
    />
  )
}